import { createAction } from 'typesafe-actions';

export const setRegionAction = createAction('filters/setRegion')<number[]>();
